module.exports = __webpack_public_path__ + "fonts/iconfont.14edfb0d.woff2";